// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const CategoryList = () => {
//   const [formData, setFormData] = useState({
//     category_name: "",
//     category_id:""
//   });
//   // const [EditFormData, setEditformdata] = useState({
//   //   category_name: "",

//   // });

//   const [stocks, setStocks] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [editMode, setEditMode] = useState(false);
//   const [selectedId, setSelectedId] = useState(null);
//   //console.log(searchTerm)
//   const handleChange = (e) => {
//     setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   useEffect(() => {
//     fetchStocks();
//   }, []);

//   const fetchStocks = async () => {
//     try {
//       const response = await axios.get(`https://ims-backend.indevconsultancy.in/admin-panel/category/`);
//       setStocks(response.data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching stocks:", error);
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.category_name) {
//       alert("Please fill in Item Name and Unit.");
//       return;
//     }

//     try {
//       if (editMode) {
//         await axios.put(`https://ims-backend.indevconsultancy.in/admin-panel/category/`, formData);
//         alert("Item updated successfully!");
//       } else {
//         await axios.post("https://ims-backend.indevconsultancy.in/admin-panel/category/", formData);
//         alert("Item added successfully!");
//       }

//       fetchStocks();
//     } catch (error) {
//       console.error("Error saving item:", error);
//       alert("Failed to save item");
//     }

//     setFormData({ stock_name: "", units: "" });
//     setEditMode(false);
//     setSelectedId(null);

//     const modal = document.getElementById("registerModal");
//     if (modal) {
//       const modalInstance = window.bootstrap.Modal.getInstance(modal);
//       modalInstance.hide();
//     }
//   };

//   const handleEdit = (item) => {
//     console.log(item);
//     setFormData({ category_id:item.category_id, category_name: item.category_name});
//     setSelectedId(item.stock_id);
//     setEditMode(true);
//     const modal = new window.bootstrap.Modal(document.getElementById("registerModal"));
//     modal.show();
//   };

//   const handleDelete = async (id) => {
//     const formData = new FormData();
//     formData.append('category_id', id);
//     if (window.confirm("Are you sure you want to delete this item?")) {
//       try {
//         await axios.delete(`https://ims-backend.indevconsultancy.in/admin-panel/category/`,formData);
//         alert("Item deleted successfully!");
//         fetchStocks();
//       } catch (error) {
//         console.error("Error deleting item:", error);
//         alert("Failed to delete item.");
//       }
//     }
//   };

//   const setSearchTerm = async (id) => {
//     try {
//       const response = await axios.get(`https://ims-backend.indevconsultancy.in/admin-panel/category/?categroy_name=${id}`);
//       setStocks(response.data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching stocks:", error);
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <div className="content">
//         <div className="container-fluid">
//           <div className="row g-3">
//             <div className="col-md-12">
//               <div className="card">
//                 <div className="card-header border-info">
//                   <form>
//                     <div className="row g-3">
//                       <div className="col-lg">
//                         <input className="form-control" onChange={(e) => setSearchTerm(e.target.value)} name="catoryname" id="categoryid" placeholder="search..."/>
//                       </div>

//                       <div className="col-lg-2">
//                         <button type="button" className="btn btn-primary w-100" >
//                           Search
//                         </button>
//                       </div>
//                       <div className="col-lg-1">
//                         <a href="#" className="btn btn-outline-dark w-100">
//                           Reset
//                         </a>
//                       </div>
//                     </div>
//                   </form>
//                 </div>

//                 <div className="card-body">
//                   <div className="row g-0 align-items-center">
//                     <div className="col-sm-7 mb-3">
//                       <h6 className="fw-bold mb-0">
//                         Total Category(s): <span>{stocks.length}</span>
//                       </h6>
//                     </div>
//                     <div className="col-sm-5 mb-3 text-end">
//                       <button
//                         className="btn btn-primary"
//                         data-bs-toggle="modal"
//                         data-bs-target="#registerModal"
//                         onClick={() => {
//                           setFormData({ stock_name: "", units: "" });
//                           setEditMode(false);
//                           setSelectedId(null);
//                         }}
//                       >
//                         Add Category
//                       </button>
//                     </div>
//                   </div>

//                   <div className="table-responsive scrollbar">
//                     <table className="table text-center table-bordered table-striped fs--1 mb-0">
//                       <thead className="bg-primary text-white">
//                         <tr>
//                           <th>S.No.</th>
//                           <th>Category Name</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {loading ? (
//                           <tr>
//                             <td colSpan="4">Loading...</td>
//                           </tr>
//                         ) : stocks.length === 0 ? (
//                           <tr>
//                             <td colSpan="4">No items found.</td>
//                           </tr>
//                         ) : (
//                           stocks.map((item, i) => (
//                             <tr key={item.category_id}>
//                               <td>{i + 1}</td>
//                               <td>{item.category_name}</td>
//                               <td>
//                                 <button
//                                   className="btn btn-sm btn-warning me-2"
//                                   onClick={() => handleEdit(item)}
//                                 >
//                                   Edit
//                                 </button>
//                                 <button
//                                   className="btn btn-sm btn-danger"
//                                   onClick={() => handleDelete(item.category_id)}
//                                 >
//                                   Delete
//                                 </button>
//                               </td>
//                             </tr>
//                           ))
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Modal */}
//       <div
//         className="modal fade"
//         id="registerModal"
//         tabIndex="-1"
//         aria-labelledby="registerModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <form onSubmit={handleSubmit}>
//               <div className="modal-header">
//                 <h5 className="modal-title" id="registerModalLabel">
//                   {editMode ? "Edit Categroy" : "Add Categroy"}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                 ></button>
//               </div>

//               <div className="modal-body">
//                 <div className="row g-3">
//                   <div className="col-md-12">
//                     <label className="form-label">Category Name</label>
//                     <input type="hidden" name="category_id" id="" value={formData.category_id} className="form-control" />
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="category_name"
//                       value={formData.category_name}
//                       onChange={handleChange}
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div className="modal-footer">
//                 <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
//                   Close
//                 </button>
//                 <button type="submit" className="btn btn-primary">
//                   {editMode ? "Update category" : "Save category"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default CategoryList;

import React, { useState, useEffect } from "react";
import axios from "axios";

const CategoryList = () => {
  const [formData, setFormData] = useState({
    category_name: "",
    category_id: "",
  });

  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(stocks.length / itemsPerPage);
  const paginatedList = stocks.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  useEffect(() => {
    fetchStocks();
  }, []);

  const fetchStocks = async () => {
    try {
      const response = await axios.get(
        `https://ims-backend.indevconsultancy.in/admin-panel/category/`
      );
      setStocks(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching stocks:", error);
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.category_name) {
      alert("Please fill in Item Name and Unit.");
      return;
    }

    try {
      if (editMode) {
        await axios.put(
          `https://ims-backend.indevconsultancy.in/admin-panel/category/`,
          formData
        );
        alert("Item updated successfully!");
      } else {
        await axios.post(
          "https://ims-backend.indevconsultancy.in/admin-panel/category/",
          formData
        );
        alert("Item added successfully!");
      }

      fetchStocks();
    } catch (error) {
      console.error("Error saving item:", error);
      alert("Failed to save item");
    }

    setFormData({ stock_name: "", units: "" });
    setEditMode(false);
    setSelectedId(null);

    const modal = document.getElementById("registerModal");
    if (modal) {
      const modalInstance = window.bootstrap.Modal.getInstance(modal);
      modalInstance.hide();
    }
  };

  const handleEdit = (item) => {
    setFormData({
      category_id: item.category_id,
      category_name: item.category_name,
    });
    setSelectedId(item.stock_id);
    setEditMode(true);
    const modal = new window.bootstrap.Modal(
      document.getElementById("registerModal")
    );
    modal.show();
  };

  const handleDelete = async (id) => {
    const formData = new FormData();
    formData.append("category_id", id);
    if (window.confirm("Are you sure you want to delete this item?")) {
      try {
        await axios.delete(
          `https://ims-backend.indevconsultancy.in/admin-panel/category/`,
          formData
        );
        alert("Item deleted successfully!");
        fetchStocks();
      } catch (error) {
        console.error("Error deleting item:", error);
        alert("Failed to delete item.");
      }
    }
  };

  const setSearchTerm = async (id) => {
    try {
      const response = await axios.get(
        `https://ims-backend.indevconsultancy.in/admin-panel/category/?categroy_name=${id}`
      );
      setStocks(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching stocks:", error);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <div className="row g-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header border-info">
                  <form>
                    <div className="row g-3">
                      <div className="col-lg">
                        <input
                          className="form-control"
                          onChange={(e) => setSearchTerm(e.target.value)}
                          name="catoryname"
                          id="categoryid"
                          placeholder="search..."
                        />
                      </div>
                      <div className="col-lg-2">
                        <button type="button" className="btn btn-primary w-100">
                          Search
                        </button>
                      </div>
                      <div className="col-lg-1">
                        <a href="#" className="btn btn-outline-dark w-100">
                          Reset
                        </a>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="card-body">
                  <div className="row g-0 align-items-center">
                    <div className="col-sm-7 mb-3">
                      <h6 className="fw-bold mb-0">
                        Total Category(s): <span>{stocks.length}</span>
                      </h6>
                    </div>
                    <div className="col-sm-5 mb-3 text-end">
                      <button
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#registerModal"
                        onClick={() => {
                          setFormData({ stock_name: "", units: "" });
                          setEditMode(false);
                          setSelectedId(null);
                        }}
                      >
                        Add Category
                      </button>
                    </div>
                  </div>

                  <div className="table-responsive scrollbar">
                    <table className="table text-center table-bordered table-striped fs--1 mb-0">
                      <thead className="bg-primary text-white">
                        <tr>
                          <th>S.No.</th>
                          <th>Category Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="3">Loading...</td>
                          </tr>
                        ) : paginatedList.length === 0 ? (
                          <tr>
                            <td colSpan="3">No items found.</td>
                          </tr>
                        ) : (
                          paginatedList.map((item, i) => (
                            <tr key={item.category_id}>
                              <td>
                                {(currentPage - 1) * itemsPerPage + i + 1}
                              </td>
                              <td>{item.category_name}</td>
                              <td>
                                <button
                                  className="btn btn-sm text-white me-2"
                                  style={{background:"#28a745"}}
                                  onClick={() => handleEdit(item)}
                                >
                                  Edit
                                </button>
                                <button
                                  className="btn btn-sm text-white"
                                  style={{background:"#8b1a1a"}}
                                  onClick={() => handleDelete(item.category_id)}
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                    <span>
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="registerModal"
        tabIndex="-1"
        aria-labelledby="registerModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title" id="registerModalLabel">
                  {editMode ? "Edit Categroy" : "Add Categroy"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-12">
                    <label className="form-label">Category Name</label>
                    <input
                      type="hidden"
                      name="category_id"
                      value={formData.category_id}
                      className="form-control"
                    />
                    <input
                      type="text"
                      className="form-control"
                      name="category_name"
                      value={formData.category_name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  {editMode ? "Update category" : "Save category"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryList;
